import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import DashboardTemplate from '../templates/DashboardTemplate';
import Button from '../atoms/Button';
import api from '../../services/api';
import { useAuth } from '../../hooks/useAuth';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function OwnerUpgradeForm() {
  const stripe = useStripe();
  const elements = useElements();
  const { login } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      // 1) create a $5 PaymentIntent
      const { data: { clientSecret } } = await api.post('/stripe/create-payment-intent', {
        amount: 500
      });
      // 2) confirm card in‐app
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: { card: elements.getElement(CardElement) }
      });
      if (result.error) {
        setError(result.error.message);
      } else if (result.paymentIntent.status === 'succeeded') {
        // 3) upgrade server‐side and get fresh JWT
        const { data: { user, token } } = await api.post('/auth/upgrade');
        // 4) persist new JWT + user in context + localStorage
        login(user, token);
        // 5) redirect
        window.location.href = '/';
      }
    } catch (err) {
      console.error(err);
      setError('Payment or upgrade failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && <div className="text-red-600">{error}</div>}
      <CardElement options={{ style: { base: { fontSize: '16px' } } }} />
      <Button type="submit" disabled={!stripe || busy} className="w-full">
        {busy ? 'Processing…' : 'Pay $5 to Upgrade'}
      </Button>
    </form>
  );
}

export default function PaymentPage() {
  return (
    <DashboardTemplate>
      <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow">
        <h1 className="text-3xl font-bold mb-4">Become an Owner</h1>
        <Elements stripe={stripePromise}>
          <OwnerUpgradeForm />
        </Elements>
      </div>
    </DashboardTemplate>
  );
}
